import React from "react";
import GalleryManager from "@/components/shared/GalleryManager";

const WardenGallery = ({ permissions }) => {
  return (
    <div className="container mx-auto py-2">
      <GalleryManager role="warden" permissions={permissions} />
    </div>
  );
};

export default WardenGallery;
